import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackQuickOrderListItemsUploadedParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackQuickOrderListItemsUploaded";

const useTrackQuickOrderListItemsUploaded = (
    parameters: TrackQuickOrderListItemsUploadedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.quickOrderListItemsUploaded, parameters, options);
};

export default useTrackQuickOrderListItemsUploaded;
